import React from 'react';
import { motion } from 'framer-motion';
import { VStack, Heading, Text } from '@chakra-ui/react';

const PreferencesHeader = () => {
  return (
    <motion.div
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.3 }}
    >
      <VStack spacing={3} textAlign="center">
        <Heading 
          fontSize="3xl"
          className="font-semibold text-stone-800"
        >
          Set Your Preferences
        </Heading>
        <Text 
          fontSize="md"
          maxW="md"
          className="leading-relaxed text-amber-800"
        >
          Help me find the perfect pieces for you
        </Text>
      </VStack>
    </motion.div>
  );
};

export default PreferencesHeader;